import { FC } from 'react'
import { formatCurrency } from '@/utils/format'

interface InvoiceTotalsProps {
  subtotal: string
  taxRate: string
  taxAmount: string
  total: string
  currency: string
  totalInUsdc: string
  paymentToken?: string
}

export const InvoiceTotals: FC<InvoiceTotalsProps> = ({
  subtotal,
  taxRate,
  taxAmount,
  total,
  currency,
  totalInUsdc,
  paymentToken = 'USDC',
}) => {
  const taxRateNum = parseFloat(taxRate)
  const hasTax = taxRateNum > 0

  return (
    <div className="flex justify-end">
      <div className="w-full max-w-[240px] space-y-2">
        {/* Subtotal */}
        <div className="flex justify-between text-sm">
          <span className="text-[#6b7280]">Subtotal</span>
          <span className="text-[#111827]">{formatCurrency(subtotal, currency)}</span>
        </div>

        {/* Tax */}
        {hasTax && (
          <div className="flex justify-between text-sm">
            <span className="text-[#6b7280]">Tax ({taxRateNum}%)</span>
            <span className="text-[#111827]">{formatCurrency(taxAmount, currency)}</span>
          </div>
        )}

        {/* Divider */}
        <div className="border-t border-[#d1d5db] my-2" />

        {/* Total */}
        <div className="flex justify-between items-baseline">
          <span className="text-sm font-medium text-[#111827]">Total due</span>
          <div className="text-right">
            <span className="text-xl font-semibold text-[#111827]">
              {formatCurrency(total, currency)}
            </span>
            <p className="text-xs text-[#6b7280] mt-0.5">
              ≈ {parseFloat(totalInUsdc).toLocaleString()} {paymentToken}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
